import { React, createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { supabase } from '../supabase/client';

export const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

const login = (email, password, captchaToken) =>
  supabase.auth.signInWithPassword({
    email,
    password,
    options: { captchaToken }
  });

const signOut = () => supabase.auth.signOut();

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(false);
  const [user, setUser] = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const getSession = async () => {
      const { data } = await supabase.auth.getSession();
      setSession(data.session);
      setUser(data.session ? data.session.user : null);
      setAuth(data.session ? true : false);
      setLoading(false);
    };
    getSession();

    const { data } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'TOKEN_REFRESHED') {
        // Update the session in your state
        setSession(session);
        setUser(session ? session.user : null);
        setAuth(session ? true : false);
      } else if (event === 'SIGNED_OUT') {
        // Clear the session and user data
        setSession(null);
        setUser(null);
        setAuth(false);
      }
    });

    return () => {
      data.subscription.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{
        auth,
        user,
        session,
        login,
        signOut
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthProvider;
